<template>
  <div class="error-wrap">
    <div class="error-code">403</div>
    <h2 class="error-title">暂无访问权限</h2>
    <p class="error-desc">
      当前账号没有访问该功能的权限，请联系管理员为当前角色开通后再试。
    </p>

    <div class="btn-box">
      <button class="btn back" @click="goBack">返回上一页</button>
      <button class="btn home" @click="goHome">回到首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageForbidden",
  methods: {
    // 保留返回入口，避免用户只能手动修改地址。
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss" scoped>
.error-wrap {
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: var(--app-bg);
}

.error-code {
  font-size: 160px;
  font-weight: 900;
  line-height: 1;
  margin-bottom: 20px;
  color: var(--brand);
  text-shadow: var(--glow);
}

.error-title {
  margin: 0 0 12px;
  color: var(--title);
  font-size: 28px;
  font-weight: 600;
}

.error-desc {
  max-width: 580px;
  margin: 0 auto 52px;
  color: var(--text-muted);
  font-size: 16px;
  line-height: 1.75;
  text-align: center;
}

.btn-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 18px;
}

.btn {
  padding: 13px 28px;
  border: none;
  border-radius: var(--card-radius);
  box-shadow: var(--btn-shadow);
  color: #fff;
  cursor: pointer;
  font-size: 15px;
}

.back {
  background: rgba(12, 113, 207, 0.8);
}

.home {
  background: var(--brand-grad);
}

@media screen and (max-width: 640px) {
  .error-code {
    font-size: 102px;
  }

  .error-title {
    font-size: 22px;
  }
}
</style>
